module.exports = __webpack_public_path__ + "static/media/full_time_tutor_intro_business.7e35e148.jpg";